<template>
  <BaseButton5
    class="button-edit"
    @click="$emit('click')"
    :disabled="disabled"
  >{{lang.edit}}</BaseButton5>
</template>

<script>
import BaseButton5 from './BaseButton5.vue'
export default {
  components: {
    BaseButton5
  },
  props: {
    lang: {
      type: Object,
      default () {
        return {
          edit: '修改'
        }
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.button-edit {
  @media (--mediaPc) {
    min-width: 60px;
  }
  @media (--mediaMobile) {
    font-size: var(--textSize6);
    min-width: 38px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/button/EditButton.vue